import message from 'assets/icons/message.svg';
import { Img } from 'shared/ui/imgStyledComponent';

export const MessageIcon = () => {
	return <Img role="image" src={message} />;
};
